import { render, staticRenderFns } from "./vuegoodtable.vue?vue&type=template&id=a8b56228&scoped=true&"
import script from "./vuegoodtable.vue?vue&type=script&lang=js&"
export * from "./vuegoodtable.vue?vue&type=script&lang=js&"
import style0 from "./vuegoodtable.vue?vue&type=style&index=0&id=a8b56228&scoped=true&lang=css&"
import style1 from "./vuegoodtable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b56228",
  null
  
)

export default component.exports